import React from "react";
import "./HeroSec.css";

const HeroSec = () => {
  return (
    <div className="hero-section">
      <div className="content">
        <h1>
          Let's Create Your
          <br />
          <span>Dream Interior</span>
        </h1>
        <p>
          The world needs innovators and problem solvers who turn challenges
          into greater opportunities.
        </p>
        <a href="/" className="btn">
          Get Started
        </a>
      </div>
    </div>
  );
};

export default HeroSec;
